import React, { useEffect, useState, useRef } from 'react';

import {
    Box,
    Stack,
    Typography,
    Paper,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
    InputAdornment,
    IconButton,
    List,
    ListSubheader,
    ListItemButton,
    ListItemText,
    ListItem,
    Skeleton,
    FormControl,
    Grid,
    styled,
    Chip,
    Tooltip
} from '@mui/material';

import { CommonIcons, icons } from '../common/CommonIcons';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useItems, itemTypes, targetTypes, configuration as itemConfiguration } from '../../hooks/api/useItems';
import { useSystemUtils } from '../../hooks/useSystemUtils';
import { useTranslations } from "../../hooks/useTranslations";

import { spliceString } from '../../utils/formatString'

const StyledIcon = styled(Box)(({ theme }) => ({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
}));


const StyledTitle = styled(Box)(({ theme }) => ({
    fontWeight: 800,
    fontSize: '1.0rem'
}))

const StyledSubTitle = styled(Box)(({ theme }) => ({
    fontWeight: 300,
    fontSize: '0.8rem'
}))

const RenderDialog = ({
    t,
    open,
    handleExit,
    data,
    keyword,
    isLoading,
    searchInputRef,
    currencyAbb,
    handleChangeSearchKeyword,
    handleSelect
}) => {
    return (

        <Dialog
            sx={{
                '& .MuiDialog-paper':
                {
                    // width: '80%', 
                    minHeight: '90vh'
                }
            }}
            fullWidth={Boolean(true)}
            maxWidth="md"
            // TransitionProps={{ onEntering: handleEntering }}
            open={open}
            // {...other}
            onClose={handleExit}
        >
            <DialogTitle
            >
                {t('searchItems')}

                <IconButton
                    aria-label="close"
                    onClick={handleExit}
                    sx={{
                        position: 'absolute',
                        right: 10,
                        top: 10,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CommonIcons name={icons.close} />
                </IconButton>

            </DialogTitle>
            <DialogContent
                dividers
                // minHeight="100%"
                sx={{
                    // backgroundColor: 'red',
                    pl: 0,
                    pr: 0
                }}
            >
                <RenderList
                    t={t}
                    data={data}
                    searchInputRef={searchInputRef}
                    keyword={keyword}
                    isLoading={isLoading}
                    currencyAbb={currencyAbb}
                    handleChangeSearchKeyword={handleChangeSearchKeyword}
                    handleSelect={handleSelect}
                />

            </DialogContent>
        </Dialog>
    )
}

const RenderList = ({ t, data, searchInputRef, isLoading, currencyAbb, keyword, handleSelect, handleChangeSearchKeyword }) => {

    return (
        <List
            // sx={{ width: '100%', maxWidth: 360,
            //     bgcolor: 'background.paper' }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader
                    component="div"
                    id="nested-list-subheader"
                    sx={{
                        // backgroundColor: 'red'
                        // pl: 1,
                        // pr: 1
                    }}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            p: 1
                        }}
                    >
                        {/* <FormControl variant="standard"> */}
                        <TextField
                            inputRef={searchInputRef}
                            autoComplete="off"
                            margin="dense"
                            size="small"
                            label={t("searchKeyword")}
                            fullWidth
                            variant="outlined"
                            onChange={handleChangeSearchKeyword}
                            value={keyword}
                            InputProps={{
                                startAdornment:
                                    <InputAdornment position="start">
                                        <CommonIcons name={icons.search} />
                                    </InputAdornment>
                            }}
                        />
                        {/* </FormControl> */}
                    </Paper>
                </ListSubheader>
            }
        >
            <RenderListData
                data={data}
                keyword={keyword}
                isLoading={isLoading}
                currencyAbb={currencyAbb}
                handleSelect={handleSelect}
            />
            {/* {
                RenderListData()
            } */}

        </List>
    )
}

const RenderListData = ({ data, keyword, isLoading, currencyAbb, handleSelect }) => {

    if (!keyword) return <></>

    if (isLoading) {
        return (
            [1, 2, 3, 4].map((item, index) => <RenderListDataItem currencyAbb={currencyAbb} key={index} isLoading={Boolean(true)} />)
        )
    }

    return (
        <Box
            sx={{
                mt: 1
            }}
        >
            {
                data.map((item, index) =>
                    <RenderListDataItem id={item?.id} handleSelect={handleSelect} currencyAbb={currencyAbb} key={index} item={item} index={index} />
                )
            }
        </Box>
    )
}

const RenderListDataItemSkeleton = () => {
    return (
        <>
            <Skeleton
                animation="wave"
                // variant="circular"
                sx={{
                    minWidth: 100,
                    mr: 1,
                    height: 50
                }}
            />
            <ListItemText
            // fullWidth
            // height={50}
            >
                <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={20}
                />
                <Skeleton
                    variant="rectangular"
                    width={"100%"}
                    height={20}
                    sx={{
                        mt: 1
                    }}
                />
            </ListItemText>
        </>
    )
}

const RenderListDataItemDisplay = ({ item, currencyAbb }) => {

    // console.log('item', item)

    return (
        <>
            <Grid container padding={0} spacing={1}>
                <Grid item textAlign={"center"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <CommonIcons name={icons.products} sx={{ height: 30, width: 30 }} />
                </Grid>
                <Grid item flexGrow={1}>
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                    >
                        <StyledTitle>
                            {`${item?.item_name}`}
                        </StyledTitle>
                        {
                            (item?.default_uom_item_id === item?.id) &&
                            <Chip
                                label={`Default Uom`}
                                variant='outlined'
                                color={"primary"}
                                size='small'
                                sx={{
                                    ml: 1
                                }}
                            />
                        }
                    </Box>
                    <>
                        <StyledSubTitle>
                            {`${item?.description}`}
                        </StyledSubTitle>
                        <StyledSubTitle>
                            {`${item?.code}`} / {`${item?.product_code}`}
                        </StyledSubTitle>
                    </>

                </Grid>
                <Grid item md={4} textAlign={"right"} display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"flex-end"}>

                    <StyledTitle>
                        {`${currencyAbb} ${item?.uom_price}`}
                    </StyledTitle>
                    <StyledSubTitle sx={{ ml: 1 }}>
                        {item?.uom_name}
                    </StyledSubTitle>

                    {/* <StyledIcon>
                            <CommonIcons name={icons.products} />
                        </StyledIcon> */}

                </Grid>
            </Grid>
        </>
    )
}

const RenderListDataItem = ({ isLoading = false, id, index, item, currencyAbb, handleSelect }) => {
    return (
        <ListItem
            key={index}
            disablePadding
            disableGutters
            divider
        >
            <ListItemButton
                // role={undefined}
                onClick={() => {
                    if (handleSelect) {
                        handleSelect({ item, id });
                    }
                }}
                disableGutters
                sx={{
                    px: 2.5
                }}
            // dense
            >
                {
                    Boolean(isLoading) ? <RenderListDataItemSkeleton /> : <RenderListDataItemDisplay currencyAbb={currencyAbb} item={item} />

                }

            </ListItemButton>
        </ListItem>
    )
}

const RenderSearch = ({ t, setOpen, customDisplay, textProps, handleOnChangeText, selectedDisplay }) => {

    // check the custom display is set
    if (customDisplay) {
        return customDisplay({ setOpen })
    }

    return (
        <TextField
            disabled={textProps?.disabled ? textProps.disabled : false}
            margin="dense"
            size="small"
            fullWidth
            // name={id}
            label={t("itemName")}
            type="text"
            variant="outlined"
            value={textProps?.value ? textProps.value : ""}
            onChange={handleOnChangeText}
            error={textProps?.error ? textProps.error : false}
            helperText={textProps?.helperText}
            InputProps={{
                style: {
                    paddingRight: 5
                },
                endAdornment: (
                    <InputAdornment position="end">
                        {/* {JSON.stringify(selectedDisplay)} */}
                        {
                            (selectedDisplay?.selectedDisplayLabel && selectedDisplay?.selectedDisplayTooltip) &&
                            <Tooltip
                                title={`${selectedDisplay?.selectedDisplayTooltip}`}
                            >
                                <Chip
                                    variant='contained'
                                    // color='primary'
                                    label={`${selectedDisplay?.selectedDisplayLabel}`}
                                    size='small'
                                />
                            </Tooltip>
                        }
                        <IconButton
                            aria-label="open"
                            onClick={() => setOpen(true)}
                        >
                            <CommonIcons name={icons.search} />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )
}

export default function SearchItems({
    id,
    open: _open = false,
    skipSearchInput = false,
    customDisplay,
    handleOnExit = () => {},
    handleOnSelect,
    handleOnSearchChange,
    textProps,
    configs = {
        selectedDisplayLabel: ``,
        selectedDisplayTooltip: ``,
    }
}) {

    const { t } = useTranslations({ ns: ["common", "@document", "_@document"] })

    const searchInputRef = useRef()

    const [open, setOpen] = useState(false)
    const [keyword, setKeyword] = useState("")
    const [data, setData] = useState([])
    const [selectedDisplay, setSelectedDisplay] = useState()

    const { currencyAbb } = useSystemUtils()

    const { promptMessage } = useSystemPrompt()
    const { isLoading, list, filterOperatorTypes } = useItems({ itemType: itemTypes.item, targetType: targetTypes.item });

    const fetchData = async () => {

        try {

            let props = {
                limit: 30,
                skip: 0,
                sortInfo: {
                    id: "item_name",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: "item_name",
                        operator: filterOperatorTypes.contains,
                        value: keyword,
                        group: "name_group"
                    },
                    {
                        name: "code",
                        operator: filterOperatorTypes.eqOr,
                        value: keyword,
                        group: "name_group"
                    },
                    {
                        name: "product_code",
                        operator: filterOperatorTypes.eqOr,
                        value: keyword,
                        group: "name_group"
                    }
                ]
            }

            props.configuration = {
                [itemConfiguration.enableServerClientCancellation.id]: true
            }

            let response = await list(props);
            // console.log('response?.data?.items', response?.data?.items)

            const {
                items = []
            } = response?.data ? response.data : {}

            setData(items)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

    }

    useEffect(() => {

        setOpen(_open)

    }, [_open])

    useEffect(() => {

        setData([])

        // console.log('configs', configs)

        setSelectedDisplay({
            ...setSelectedDisplay,
            selectedDisplayLabel: configs?.selectedDisplayLabel,
            selectedDisplayTooltip: configs?.selectedDisplayTooltip
        })

    }, [])

    useEffect(() => {

        if (keyword) {
            fetchData({ keyword });
        } else {
            setKeyword("")
            setData([])
        }

    }, [keyword])

    useEffect(() => {

        const timeout = setTimeout(() => {

            if (open) {
                searchInputRef?.current.focus();
                // console.log('serachRef', searchInputRef?.current)
            }

        }, 100);

        return () => {
            clearTimeout(timeout);
        };

    }, [open])

    const handleOpen = () => {
        setOpen(true)
    }

    const handleExit = () => {

        setOpen(false);

        if (handleOnExit) {
            console.log('exit')
            handleOnExit();
        }
    }

    const handleSelect = ({ id, item }) => {
        setOpen(false);

        // update state
        configs.selectedDisplayLabel = spliceString({ val: item?.code, maxLength: 6 })
        configs.selectedDisplayTooltip = item?.code

        setSelectedDisplay(configs)

        if (handleOnSelect) {
            handleOnSelect({ id, item })
            handleOnExit()
        }

        // promptMessage(true, `Selected (1) item`)
    }

    const handleChangeSearchKeyword = e => {
        setKeyword(e.target.value)
    }

    const handleOnChangeText = (event) => {
        if (handleOnSearchChange) {
            handleOnSearchChange(event.target.value, event)
        }
    }

    return (
        <Box>

            {/* {JSON.stringify(open)} */}

            {
                (skipSearchInput === false) &&
                <RenderSearch
                    t={t}
                    setOpen={setOpen}
                    customDisplay={customDisplay}
                    textProps={textProps}
                    handleOnChangeText={handleOnChangeText}
                    selectedDisplay={selectedDisplay}
                />
            }

            <RenderDialog
                t={t}
                open={open}
                data={data}
                handleExit={handleExit}
                isLoading={isLoading}
                searchInputRef={searchInputRef}
                keyword={keyword}
                currencyAbb={currencyAbb}
                handleChangeSearchKeyword={handleChangeSearchKeyword}
                handleSelect={handleSelect}
            />

        </Box>
    )
}